const config = {
  baseURL:
    process.env.NODE_ENV === "production"
      ? "https://api.costapez.org/"
      : "http://localhost:1390/"
};

module.exports = config;
